export default "__VITE_ASSET__N72WZe7i__"